import { useState } from 'react';
import Slider from "react-slick";
import ItemCard from '../Product/ProductCard';
import { AbconetApi } from '../General/AbconetApi';

export class ProductCarousel extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            productCollection: []
        }
    }

    componentDidMount() {
        AbconetApi.get(this.props.dataUrl).then((data) => {
            this.setState({ productCollection: data });
        });
    }

    getCartItemFromItem(item) {
        if (this.props.cart) {
            for (var i = 0; i < this.props.cart.lines.length; i++) {
                var cartRow = this.props.cart.lines[i];
                if (cartRow.stockcode === item.stockcode) {
                    return cartRow;
                }
            }
        }
    }

    render() {
        if ((this.props.title == "Recently Ordered" || this.props.title == "Most Ordered")
            && this.state.productCollection.length == 0) {
            return null;
        }else if (this.state.productCollection == null) {
            return null;
        }

        var isInfinite = true
        var isInfinite1024 = true;
        var isInfinite800 = true;


        if (this.state.productCollection.length < 4) {
            isInfinite = false;
        }

        if (this.state.productCollection.length < 3) {
            isInfinite1024 = false;
        }

        if (this.state.productCollection.length < 2) {
            isInfinite800 = false;
        }

        var settings = {
            dots: false,
            arrows: true,
            infinite: isInfinite,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: isInfinite1024,
                        dots: true
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2,
                        infinite: isInfinite800

                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return <div className="abco-section">
            {/*<a href={this.props.viewAllUrl} className="btn btn-primary">View All</a>*/}
            <h3 className="strikeout">{this.props.title}</h3>
            <Slider {...settings}>
                   {this.state.productCollection.map((item) => {
                       return <ItemCard
                                  key={"item-row-" + item.stockcode}
                                  item={item}
                                  cartItem={this.getCartItemFromItem(item)}
                                  canAddToCart={this.props.canAddToCart}
                                  limitOrderToApprovedStocklist={this.props.limitOrderToApprovedStocklist}
                                  limitOrderToTemplateStocklist={this.props.limitOrderToTemplateStocklist}/>;
                   })}
            </Slider>
        </div>;
    }
}